export const SOOP = 'SOOP';

export const USER = 'user';

export const CHATBOT_SESSION_ID = 'soopduck_sid';
